var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<h3>Информация по контейнеру в пути № {{data.number}}</h3>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/konos-file/component.jade
 ** module id = 99
 ** module chunks = 0
 **/